import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DashboardApiService } from 'features/dashboard/api/dashboard-api.services';
import { PaginatedRequestParams } from 'features/report/routes/report-view';
import qs from 'qs';

import { DashbaordQueryKeys } from './query-keys';
// ../api/dashboard-api.services
const { getdashboard } = DashboardApiService();
export type DasboardListParams={
  Flag:string 
}
export interface UserListParams extends PaginatedRequestParams {
  Flag:string
}

const getUsersQuery = (
  params:DasboardListParams,
  options?: UseQueryOptions<any>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<any>;
} => ({
  queryKey: DashbaordQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getdashboard(params as any, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetDashboardList = (
  params: DasboardListParams,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();
     
  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};





